import { watchEffect } from 'vue'

import { useLocalStorage } from '@vueuse/core'

/**
 * Composable that helps us sync localStorage tokens with sessionStorage ones.
 * This is needed to allow cross-tab sessions (localStorage) as well as have keycloak auto-refresh tokens (via sessionStorage).
 */

const KEYCLOAK_ACCESS_TOKEN_KEY = 'kc_token_evergpt'
const KEYCLOAK_REFRESH_TOKEN_KEY = 'kc_refreshToken_evergpt'
const KEYCLOAK_ID_TOKEN_KEY = 'kc_idToken_evergpt'
const KEYCLOAK_SESSION_STATE_KEY = 'kc_sessionState_evergpt'

export const useAuthTokens = () => {
  const accessToken = useLocalStorage(KEYCLOAK_ACCESS_TOKEN_KEY, '')
  const refreshToken = useLocalStorage(KEYCLOAK_REFRESH_TOKEN_KEY, '')
  const idToken = useLocalStorage(KEYCLOAK_ID_TOKEN_KEY, '')
  const sessionState = useLocalStorage(KEYCLOAK_SESSION_STATE_KEY, '')

  // Ensure sessionStorage is synced with localStorage
  watchEffect(() => {
    sessionStorage.setItem(KEYCLOAK_ACCESS_TOKEN_KEY, accessToken.value)
    sessionStorage.setItem(KEYCLOAK_REFRESH_TOKEN_KEY, refreshToken.value)
    sessionStorage.setItem(KEYCLOAK_ID_TOKEN_KEY, idToken.value)
    sessionStorage.setItem(KEYCLOAK_SESSION_STATE_KEY, sessionState.value)
  })

  return {
    accessToken,
    refreshToken,
    idToken,
    sessionState,
  }
}
